import { render, staticRenderFns } from "./EditView.vue?vue&type=template&id=2c6e1742&"
import script from "./EditView.vue?vue&type=script&lang=js&"
export * from "./EditView.vue?vue&type=script&lang=js&"
import style0 from "./EditView.vue?vue&type=style&index=0&id=2c6e1742&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports